import { useReselector } from '@/utils/sharedHooks'
import { getCurrentUser } from '@/selectors/user.selectors'

import { useComplianceVerdict } from '../analytics/use-compliance-verdict'
import { selectAnswers } from '../compliance.selectors'
import { buildConsultUrl } from '../lib/consultLink'

interface NextStepsActionsData {
  /** The raw `tax_treatment` answer — picks the copy, and rides along on the consult event. */
  taxTreatment: unknown
  /** Scheduler link for the consult CTA; null withholds the CTA entirely. */
  consultUrl: string | null
  /** The qualification treatment, for the CTA event. Named apart from the
   *  `verdict` in `useReportEndCardSlot`, which is null unless the practice was
   *  turned away and so says nothing about the ones these actions are shown to. */
  verdictName: string
}

/**
 * What the report's closing actions are for this practice: which tax-entity copy they
 * speak in, and which consult link — if any — sits behind the first of them.
 *
 * Called by both `ReportEndCard` and `ReportStickyCta`, on purpose, the same way
 * `useReportEndCardSlot` is called in two places so they cannot disagree. Sharing the
 * buttons alone was not enough: the layer that decides *which* URL and *which* copy those
 * buttons carry is the part that can drift, and it was duplicated between the two.
 *
 * Both are redux reads and two pure functions — nothing here fetches.
 */
export const useNextStepsActions = (isPql: boolean): NextStepsActionsData => {
  const answers = useReselector(selectAnswers)
  const user = useReselector(getCurrentUser)
  const verdictName = useComplianceVerdict()

  return {
    taxTreatment: answers.tax_treatment,
    consultUrl: isPql ? buildConsultUrl(user) : null,
    verdictName,
  }
}
